//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/SelectObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CheckCriteriaAngle",1,0],[0,"CheckCriteriaDistance",1,0],[1,"ObjectsToExamine",0,"SelectObjectList",0]],[[[],"SetAllChecks",{},0,0],[[],"ClearAllChecks",{},0,0],[["check"],"SetCheck",{},1,0],[["check"],"ClearCheck",{},1,0],[[],"Examine",{},0,0],[["nChecks"],"GetResults",{R_:{results:""}},0,0],[["check","nObjects"],"GetFailedObjects",{R_:{objects:"NXObject[]"}},1,0],[["check"],"HighlightResult",{R_:{failed:''}},1,0],[["check"],"UnhighlightResult",{},1,0],[[],"UnhighlightAllResults",{},0,0],[[],"DisplayResultsAsInfo",{},0,0]],[]];
SPLM.GeometricAnalysis.ExamineGeometry = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.ExamineGeometry";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.ExamineGeometry.Check = Object.freeze({
    "ObjectTiny" : "ObjectTiny", "ObjectMisaligned" : "ObjectMisaligned", "BodyDataStructures" : "BodyDataStructures", "BodyConsistency" : "BodyConsistency", "BodyFaceIntersections" : "BodyFaceIntersections", "BodySheetBoundaries" : "BodySheetBoundaries", "FaceSmoothness" : "FaceSmoothness", "FaceSelfIntersection" : "FaceSelfIntersection", "FaceSpikesCuts" : "FaceSpikesCuts", "EdgeSmoothness" : "EdgeSmoothness", "EdgeTolerances" : "EdgeTolerances", "NumChecks" : "NumChecks"});

export default SPLM;